<template>
    <div>
        <el-dialog close-on-click-modal :model-value="topUpState" :destroy-on-close="true" @close="close" draggable align-center width="390">
            <template #header>
                <div class="title">请使用微信扫码开通</div>
            </template>
            <div class="win_body">
                <div class="table_title" > <div class="table_title_icon"></div>开通VIP套餐</div>
                <el-radio-group class="row" v-model="checkAmount" @change="radioChange" style="padding-left: 30px;width: 85%;">
                    <template v-for="(item,index) in topUpList" :key="index" >
                        <el-radio border style="margin-bottom: 10px!important;min-width:80px;"
                                  :value="item.id" >{{item.name}}</el-radio>
                    </template>
                </el-radio-group>
            </div>
            <div class="table_title" style="margin-top: 10px;"> <div class="table_title_icon"></div>付款成功后,请关闭此窗口</div>
            <div class="qrCode">
                <QrcodeVue :value="qrCodeInfo" :size="300" level="H" ></QrcodeVue>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QrcodeVue from 'qrcode.vue'

    export default {
        name: "openVip", //弹出对话窗口组件
        components:{
            QrcodeVue,
        },
        props: {
        },
        data() {
            return {
                topUpState: false,      //充值窗口
                qrCodeInfo:'',          //二维码信息
                topUpList:[],           //充值集合
                checkAmount:null,       //选择套餐
            }
        },
        methods:{

            /**
             * 选择vip套餐
             */
            radioChange(e){
                this.qrCodeInfo = 'https://jxkj1987.cn/staticfile/wxQRcodeFile/pay/shopid='+
                    this.$store.state.shopInfo.id +'&companyid=' + this.$store.state.companyInfo.companyId +
                    '&id=' + e + '&type=1';
            },

            /**
             * 关闭vip窗口
             */
            close(){
                this.topUpState = false;
                location.reload();
            },

            /**
             * 初始化数据
             */
            initData(e){

                //获取套餐
                this.$POST("/customer/EomsOssSpacePackagesConfig/config/page",
                    {shopId: this.$store.state.shopInfo.id, businessType: 1}).then(res => {
                    this.topUpList = res.data.records;
                    if(this.topUpList && this.topUpList.length > 0){
                        this.qrCodeInfo = 'https://jxkj1987.cn/staticfile/wxQRcodeFile/pay/shopid='+
                            this.$store.state.shopInfo.id +'&companyid=' + this.$store.state.companyInfo.companyId +
                            '&id=' + this.topUpList[0].id + '&type=1';
                        this.checkAmount = this.topUpList[0].id;
                    }
                    this.topUpState = true;
                });

            },
        },
        mounted() {
        }
    }
</script>

<style scoped>

    .qrCode{
        position: relative;
        left: 0;
        right: 0;
        margin: auto;
        width: 300px;
        margin-top: 20px;
    }
    .win_body{
        position: relative;
        width: 100%;
    }
    .title{
        font-weight: 800;
        font-size: 17px;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-dialog__body){
        padding-bottom: 8px;
    }
    /*radio样式*/
    :deep(.el-radio) {
        margin-right: 10px!important;
    }
    .table_title{
        position: relative;
        height: 30px;
        font-size: 16px;
    }
    .table_title_icon{
        position: relative;
        bottom: 0;
        height: 12px;
        width: 6px;
        background: linear-gradient(to bottom, #ff6633, #ff6633);
        border-radius: 4px;
        margin-right: 4px;
        display: inline-block;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-button+.el-button) {
        color: #ffffff;
    }
    :deep(.el-form--inline .el-form-item){
        margin-right: 20px;
    }


</style>
